import { render, staticRenderFns } from "./gradeCard.vue?vue&type=template&id=d6e3e27c&scoped=true"
import script from "./gradeCard.vue?vue&type=script&lang=js"
export * from "./gradeCard.vue?vue&type=script&lang=js"
import style0 from "./gradeCard.vue?vue&type=style&index=0&id=d6e3e27c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e3e27c",
  null
  
)

export default component.exports